export const styles = theme => ({
  alertTitle: {
    fontSize: 24
  },
  highlight: {
    color: theme.palette.green.color
  },
  standardHighlight: {
    fontWeight: 400
  },
})
